import { type JSX } from 'react';

import { DropdownItem, DropdownItemClickType, TextDropdownButton } from 'Components/Buttons/DropdownButton';
import { BasicAuthHandler } from 'Helpers/Auth/BasicAuth/BasicAuthHandler';
import { AuthState } from 'Models/Auth';

import styles from './DDQPublicHeader.module.css';

export interface DDQPublicHeaderProps {
    basicAuthHandler: BasicAuthHandler;
}

export const DDQPublicHeader = (props: DDQPublicHeaderProps): JSX.Element => {
    const userEmail = props.basicAuthHandler.getAuthenticatedUserEmail();
    const headerProfileDropdownItems: DropdownItem[] = [
        {
            _type: DropdownItemClickType.ONCLICK,
            text: 'Log Out',
            onClick: () => props.basicAuthHandler?.logout(AuthState.LOGGED_OUT),
        },
    ];

    return (
        <div className={styles.header}>
            <div className={styles.headerRight}>
                <TextDropdownButton dropdownItems={headerProfileDropdownItems} text={userEmail ? userEmail : 'Settings'} />
            </div>
        </div>
    );
};
